import React from "react"
import { Container } from "react-bootstrap"
import { DownloadSectionStyles } from "./DownloadSection.styles"

const DownloadSection = () => {
  return (
    <DownloadSectionStyles className="py-5 px-4 px-lg-2 secondary-blue-3-background ">
      <Container className="terms-and-condition">
        <h1 className="mb-4">TERMS & CONDITIONS</h1>
        <h5 className=" text-white">
          Effective from: November 5, 2020.
        </h5>
      </Container>
    </DownloadSectionStyles>
  )
}

export default DownloadSection
